<script setup lang="ts">
import { FhText } from '@fareharbor-com/beacon-vue';
import BaseFlexbox from '@/components/ui/BaseFlexbox/BaseFlexbox.vue';
import PoweredByLogo from './PoweredByLogo.vue';
</script>

<template>
  <BaseFlexbox
    alignItems="center"
    justifyContent="center"
    class="border py-2 bg-neutral-600 text-white"
    dataTestId="footer-flexbox"
  >
    <FhText
      tag="span"
      variant="body-md"
      alignment="center"
      weight="bold"
      class="mr-1"
    >
      Powered by
    </FhText>
    <PoweredByLogo />
  </BaseFlexbox>
</template>
